<template>
  <div>
    <fieldset>
      <div class="col-md-1 col-md-offset-10">
        <a @click="removeData">
          <span class="glyphicon glyphicon glyphicon-remove"></span>
        </a>
      </div>

      <div class="form-group col-md-6 col-md-offset-3">
        <label for="animal_name">Heifer Animal</label>

        <div class="input-group">
          <input type="text"
            class="form-control"
            id="animal_name"
            :value="data.animal_name"
            disabled>
          <span class="input-group-btn">
            <button class="btn btn-default" 
              :class="{disabled: !this.hasFreeOtherAnimals}"
              type="button" 
              @click="hasFreeOtherAnimals ? enableEditHeifer() : ''" 
              :disabled="isReadOnly">
              <span class="glyphicon glyphicon-pencil"></span>
            </button>
          </span>
        </div><!-- /input-group -->
      </div>

      <modal v-if="showEditHeiferModal">
        <div slot="header">
          <h3>Select Heifer Animal</h3>
        </div>
        <div slot="body">
          <model-select v-model="heifer" :options="freeOtherAnimalsOptions" >
          </model-select>
        </div>
        <div slot="footer">
          <button class="modal-default-button btn btn-success" @click="editHeifer(heifer) ; showEditHeiferModal = false">
            Update
          </button>
          <button class="modal-default-button btn btn-default" @click="disableEditHeifer">
            Cancel
          </button>
        </div>
      </modal>
      <div class="form-group col-md-6 col-md-offset-3">
        <label for="date_required">Required by date</label>
        <input type="date"
               class="form-control"
               id="date_required"
               :min="minDate"
               @change="updateData"
               v-model="data.date_required"
               :disabled="isReadOnly">
      </div>

      <div class="form-group col-md-6 col-md-offset-3">
        <label for="contact_name">Contact Name</label>
        <input type="text"
               class="form-control"
               id="contact_name"
               @change="updateData"
               v-model="data.contact_name"
               :disabled="isReadOnly">
      </div>

      <div class="form-group col-md-6 col-md-offset-3">
        <label for="contact_phone">Contact Number</label>
        <input type="text"
               class="form-control"
               id="contact_phone"
               @change="updateData"
               v-model="data.contact_phone"
               :disabled="isReadOnly">
      </div>

      <div class="form-group col-md-6 col-md-offset-3">
        <drug-allocation :animal-name="item.text || data.animal_name"
                         :drugs="dcatDrugs"
                         :allocations="data.allocations"
                          @new-allocations="updateAllocations"
                         :drugs-used-last-year="drugsUsedLastYear[data.client_animal] || {}"
                         :is-read-only="isReadOnly">
        </drug-allocation>
      </div>
    </fieldset>
  </div>
</template>

<script>
import 'vue-search-select/dist/VueSearchSelect.css'
import DrugAllocation from './DrugAllocation'
import { mapActions, mapGetters } from 'vuex'
import Modal from '@/components/Modal'
import { ModelSelect } from 'vue-search-select'

export default {
  components: {
    DrugAllocation,
    Modal,
    ModelSelect,
  },
  props: {
    hdcoId: String,
    model: Object,
    dcatDrugs: Array,
    isNew: Boolean,
    drugsUsedLastYear: Object,
  },
  data() {
    return {
      showEditHeiferModal: false,
      data: {},
      // TODO: remove item
      item: {
        value: '',
        text: ''
      },
      heifer: {},
    }
  },
  created: function() {
    this.data = Object.assign({}, this.model)
    this.item = {
      value: this.data.animal_ezyvet_id,
      text: this.data.animal_name,
    }
  },
  methods: {
    ...mapActions('currentConsult', ['setFieldValue']),
    enableEditHeifer: function ()
    {
			this.heifer = {
				value: this.freeOtherAnimals[0].animal_ezyvet_id,
				text: this.freeOtherAnimals[0].animal_name,
			}
      this.showEditHeiferModal = true
    },
    disableEditHeifer: function ()
    {
      this.showEditHeiferModal = false
    },
    editHeifer: function (heifer)
    {
      this.data.animal_ezyvet_id = heifer.value
      this.data.animal_name = heifer.text
      this.updateData()
    },
    updateAllocations: function (payload) {
      this.data.allocations =  payload.allocations
      this.updateData()
    },
    updateData: function () {
      let newNonHerdDcos = this.getFieldValue(this.isNew ? 'NEW_NON_HERD_DCO' : 'NON_HERD_DCO', 'DryCowAndTeatsealOrder')
      this.$set(newNonHerdDcos, this.hdcoId , this.data)
      this.setFieldValue({
        fieldName: this.isNew ? 'NEW_NON_HERD_DCO' : 'NON_HERD_DCO',
        stepName: 'DryCowAndTeatsealOrder',
        value: newNonHerdDcos,
      })
    },
    removeData: function() {
			if (this.isNew) {
				let newNonHerdDcos = this.getFieldValue('NEW_NON_HERD_DCO', 'DryCowAndTeatsealOrder')

				this.$delete(newNonHerdDcos, this.hdcoId)

				this.setFieldValue({
					fieldName:'NEW_NON_HERD_DCO',
					stepName: 'DryCowAndTeatsealOrder',
					value: newNonHerdDcos,
				})
			} else {
				let nonHerdDcos = this.getFieldValue('NON_HERD_DCO', 'DryCowAndTeatsealOrder')

        // we dont delete HDCOs coming from the backend, just mark them for
        // deletion. this way we dont loose all the info created on previous
        // consult
				this.$set(nonHerdDcos[this.hdcoId], 'delete',  true)
				this.$set(nonHerdDcos[this.hdcoId], 'allocations', [])

				this.setFieldValue({
					fieldName: 'NON_HERD_DCO',
					stepName: 'DryCowAndTeatsealOrder',
					value: nonHerdDcos,
				})
			}
    }
  },
  computed: {
    ...mapGetters('currentConsult', ['getFieldValue', 'freeOtherAnimals', 'hasFreeOtherAnimals', 'isReadOnly']),
    freeOtherAnimalsOptions: function ()
    {
      return this.freeOtherAnimals.map((animal) => { return { value: animal.animal_ezyvet_id, text: animal.animal_name }})
    },
    minDate: function () {
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return `${yyyy}-${mm}-${dd}`;
    },
  },
  watch: {
    item: function(newValue) {
      this.data.animal_ezyvet_id = newValue.value
    }
  },
};
</script>
